import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, injectIntl } from 'react-intl';
import { compose, prop } from 'ramda';

import {
  Container,
  TextWrapper,
  ImageWrapper,
  Image,
  Title,
  Text,
  ImageCell,
  Content,
  SectionTitle,
} from './vendorSection.styles';
import { EntityRefData } from '../../../shared/components/entityRefData';
import messages from './vendorSection.messages';
import { renderWhenNotNil } from '../../../shared/utils/rendering';
import { HiddenOnPlatform } from '../../../shared/components/hiddenOnPlatform';
import { Breakpoints } from '../../../theme/media';

const IMAGE_SIZES = [160, 384, 640, 960];

export class VendorSectionComponent extends PureComponent {
  static propTypes = {
    data: PropTypes.object,
    intl: PropTypes.object,
  };

  static defaultProps = {
    data: {},
  };

  render() {
    return (
      <Container>
        <HiddenOnPlatform below={Breakpoints.TABLET_PORTRAIT}>
          <SectionTitle>
            <FormattedMessage {...messages.title} />
          </SectionTitle>
        </HiddenOnPlatform>
        <Content>
          <EntityRefData id={prop('image')(this.props.data)}>
            {renderWhenNotNil(({ file }) => (
              <ImageCell>
                <ImageWrapper>
                  <Image disableRatioCalculation file={file} imgProps={{ sizes: '50vw' }} sizes={IMAGE_SIZES} />
                </ImageWrapper>
              </ImageCell>
            ))}
          </EntityRefData>
          <TextWrapper>
            <HiddenOnPlatform above={Breakpoints.TABLET}>
              <SectionTitle>
                <FormattedMessage {...messages.title} />
              </SectionTitle>
            </HiddenOnPlatform>

            <Title>
              <FormattedMessage {...messages.name} values={{ name: this.props.data.firstName }} />
            </Title>
            <Text>{this.props.data.intro}</Text>
          </TextWrapper>
        </Content>
      </Container>
    );
  }
}

export const VendorSection = compose(injectIntl)(VendorSectionComponent);
